import { useState } from "react";
import { Col, useIsMobile } from "./Flexbox";
import Text from "./Text";
import TruncatedText from "./TruncatedText";
import Spinner from "./Spinner";

const HIDE_SCROLLBAR = 'users-table-no-scrollbar';
const COLUMNS = [
    {key: 'name', label: 'Nombre', width: {flex: '2 1 200px', minWidth: '140px'}},
    {key: 'email', label: 'Correo', width: {flex: '3 1 280px', minWidth: '200px'}},
    {key: 'roleName', label: 'Rol de permisos', width: {flex: '2 1 200px', minWidth: '150px'}}, //Fixed, as a user can have multiple roles
    {key: 'status', label: 'Estado', width: {flex: '1 1 120px', minWidth: '120px'}}
];
const ACTION_WIDTH = {flex: '0 0 90px', minWidth: '90px'};

const UsersTable = props => {
    const isMobile = useIsMobile();
    const [hoveredRow, setHoveredRow] = useState(null);
    const isDark = props.theme.White !== "#FFFFFF";
    const rowColor = isDark ? props.theme.Ey : props.theme.Ed;
    const hoverColor = isDark ? props.theme.FOURFOUR : props.theme.Ey;

    const styles = {
        row: {
            display: 'flex', width: '100%', height: '38px', alignItems: 'center', boxSizing: 'border-box',
            border: `0.5px solid ${props.theme.Ey}`, borderRadius: '4px', backgroundColor: rowColor
        },
        col: (width) => ({
            ...width, display: 'flex', alignItems: 'center', boxSizing: 'border-box', padding: '0 16px'
        }),
        truncate: {
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%'
        }
    }

    return (
        <div className={isMobile ? HIDE_SCROLLBAR : undefined} style={{width: '100%', flex: 1, minHeight: 0, overflowX: 'auto', overflowY: 'auto', marginTop: 10}}>
            <style>{`.${HIDE_SCROLLBAR}::-webkit-scrollbar { display: none; }`}</style>
            <div style={{minWidth: 'min-content', maxWidth: '100%'}}>
                <div style={{position: 'sticky', top: 0, zIndex: 1, backgroundColor: rowColor}}>
                    <div style={styles.row}>
                        {COLUMNS.map(col => (
                            <div key={col.key} onClick={() => props.requestSort(col.key)} style={{...styles.col(col.width), height: '36px', cursor: 'pointer', userSelect: 'none'}}>
                                <Text size={15} weight="medium" color={props.theme.ONED}>{col.label}</Text>
                                <Text size={12} style={{marginLeft: '4px'}}>{props.getIcon(col.key)}</Text>
                            </div>
                        ))}
                        <div style={styles.col(ACTION_WIDTH)}/>
                    </div>
                </div>
                {props.isLoading ? (
                    <Col style={{justifyContent: 'center', alignItems: 'center', minHeight: 200, width: '100%'}}>
                        <Spinner theme={props.theme}/>
                    </Col>
                ) : props.users.map((user, index) => {
                    const statusInfo = props.formatStatus(user.enabled, user.status);
                    const rowKey = user.username || user.email || index;
                    return (
                        <div key={rowKey} onMouseEnter={() => setHoveredRow(rowKey)} onMouseLeave={() => setHoveredRow(null)} style={{...styles.row, backgroundColor: hoveredRow === rowKey ? hoverColor : rowColor}}>
                            <div style={styles.col(COLUMNS[0].width)} title={user.name}>
                                <Text size={15} color={props.theme.ONED} style={styles.truncate}>{user.name}</Text>
                            </div>
                            <div style={styles.col(COLUMNS[1].width)} title={user.email}>
                                <Text size={15} color={props.theme.SEVENB} style={styles.truncate}>{user.email}</Text>
                            </div>
                            <div style={styles.col(COLUMNS[2].width)}>
                                <TruncatedText text={user.roleName} size={15} color={props.theme.SEVENB} popoverBackground={props.theme.Alfalfa}/>
                            </div>
                            <div style={styles.col(COLUMNS[3].width)}>
                                <Text size={15} color={statusInfo.color}>{statusInfo.text}</Text>
                            </div>
                            <div style={{...styles.col(ACTION_WIDTH), justifyContent: 'flex-end'}}>
                                <Text style={{cursor: 'pointer', transition: 'transform 2s ease'}} size={15} onClick={() => props.onEdit(user)} color={props.theme.SEVENB}>Editar</Text>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default UsersTable;